export default __webpack_public_path__ + "static/media/04.61c00d2b.png";